import disabled from '../providers/disabled';
import assign from 'lodash/assign';
import { httpRequestTiming } from './lib/httpRequestTiming';

export const metrics = {
  use: metricsProvider => {
    assign(metrics, metricsProvider);
  },
  httpRequestTiming: (...args) => httpRequestTiming(...args),
};

metrics.use(disabled());



// WEBPACK FOOTER //
// ./src/metrics/index.js